import { FC, useMemo, useRef } from 'react';

import HotTable, { HotColumn } from '@handsontable/react';
import { IList } from 'core/API/listApi';
import { PERFCT_SHELF_CRITERIA } from 'pages/ListManagement/const';

import { MObjectifEMerchHeader, translateData, translateHeaders } from './helpers/HeadersList';
import Grid from '../Grid';
import { requireTitle } from './helpers/utils';
import { listValidator, numberValidator } from '../Validators';
import { AutoCompleteRenderer, NumberRenderer } from './helpers/customRenderers';

export const MObjectifEMerch: FC<{
    list: IList;
    toolId: number;
}> = ({ list, toolId }) => {
    const hotRef = useRef<React.ElementRef<typeof HotTable> | null>(null);
    const translatedHeaders = translateHeaders(MObjectifEMerchHeader);
    const translatedCriteria = translateData(PERFCT_SHELF_CRITERIA);
    const mapCriteria: any = {};
    const mapIDToCriteria: any = {};
    translatedCriteria.forEach((tC, i) => {
        mapCriteria[tC] = PERFCT_SHELF_CRITERIA[i].split('.')[2];
        mapIDToCriteria[PERFCT_SHELF_CRITERIA[i].split('.')[2]] = tC;
    });

    const afterValidate = (listToValidate: IList) => {
        const newData = [...listToValidate.data].map((row) => {
            if (row[0]) {
                const newRow = [...row];
                newRow[0] = mapCriteria[newRow[0] as string];
                return newRow;
            }
            return row;
        });

        return { ...listToValidate, data: newData };
    };

    const formatList = (l: IList) => {
        const newData = l.data.map((data) => {
            const newRow = [...data];
            newRow[0] = mapIDToCriteria[newRow[0] as any] || newRow[0];
            return newRow;
        });

        return {
            ...l,
            data: newData,
        };
    };

    const formatedList = useMemo(() => formatList(list), [list.data, list.name]);

    return (
        <Grid
            toolId={toolId}
            headers={MObjectifEMerchHeader}
            list={formatedList}
            paramHotRef={hotRef}
            afterValidate={afterValidate}
        >
            <HotColumn
                validator={listValidator(translatedCriteria)}
                title={requireTitle(translatedHeaders[0])}
                source={translatedCriteria}
                type="autocomplete"
            >
                <AutoCompleteRenderer list={translatedCriteria} hot-renderer />
            </HotColumn>
            <HotColumn title={requireTitle(translatedHeaders[1])} type="text" validator={numberValidator()} />
            <HotColumn
                title={requireTitle(translatedHeaders[2])}
                allowEmpty={false}
                type="text"
                validator={numberValidator()}
            />
        </Grid>
    );
};
